export default function headerScroll() {
  const mqlHeader = window.matchMedia('screen and (max-width: 980px)');
  const headerManage = {
    $window: $(window),
    $body: $('body'),
    isScrolled: false,
    handlerScroll() {
      const targetPosition = window.innerHeight;
      const scrollTop = this.$window.scrollTop();

      if (scrollTop > targetPosition) {
        if (!this.isScrolled) {
          this.$body.addClass('_scroll');
          this.isScrolled = true;
        }
      } else if (this.isScrolled) {
        this.$body.removeClass('_scroll');
        this.isScrolled = false;
      }
    },
    active() {
      this.$window.on('scroll.headerManage', this.handlerScroll.bind(this));
    },
    inactive() {
      this.$window.off('scroll.headerManage');
      this.$body.removeClass('_scroll');
    },
  };

  function changeHeaderScroll(mql) {
    if (mql.matches) {
      headerManage.inactive();
    } else {
      headerManage.active();
    }
  }
  mqlHeader.addListener(changeHeaderScroll);
  changeHeaderScroll(mqlHeader);
}
